// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7pS-D","icon":"styles_icon__WtbA6"};